App = App || {};

App.TransactionDetail = (function ($, Vue) {
	"use strict";

	var $modal;
	function init(rootElement) {
		rootElement = rootElement || document.getElementById("transaction-detail-app");

		if (!rootElement || rootElement.dataset.mounted)
			return;

		rootElement.dataset.mounted = "1";

		$modal = $(rootElement).closest(".modal");

		new Vue({
			el: rootElement,
			data: {
				isLoading: false,
				isSaving: false,
				isSaved: false,
				alertMessage: "",
				alertErrors: [],
				countries: [],
				transaction: {
				},
				statusList: ["Open", "Closed", "Canceled"]
			},

			computed: {
				hasSerials: function () {
					return Array.isArray(this.transaction.serials) && this.transaction.serials.length > 0;
				},

				currentCountry: function () {
					return this.countries.find(c => c.code === this.transaction?.shippingInformation?.country);
				},

				currentRegions: function () {
					return this.currentCountry?.regions || [];
				},

				statusClass: function () {
					switch (this.transaction.status) {
						case "Open": return "success";
						case "Closed": return "warning";
						case "Canceled": return "danger";
						default: return "light";
					}
				},

				initiatedOnComputed: {
					get() {
						if (!this.transaction.initiatedOn)
							return "";

						const initiatedOn = new Date(this.transaction.initiatedOn);
						if (isNaN(initiatedOn))
							return "";

						const pad = n => String(n).padStart(2, "0");
						return `${initiatedOn.getFullYear()}-${pad(initiatedOn.getMonth() + 1)}-${pad(initiatedOn.getDate())}`;
					}
				},

				formattedAmount: {
					get() {
						var amount = Number(this.transaction.amount);
						return (amount < 0) ? "(" + Math.abs(amount) + ")" : Math.abs(amount);
					},
					set(value)
					{
						this.transaction.amount = Number(value) || 0;
					}
				}
			},

			methods: {
				pricesByAspect: function (item, aspect) {
					var prices = Array.isArray(item && item.prices) ? item.prices : [];
					return prices.filter((price) => price.aspect === aspect);
				},

				formatDate(value) {
					if (!value)
						return "";

					const s = String(value);

					const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
					if (m) {
						return `${m[2]}/${m[3]}/${m[1]}`;
					}

					const date = new Date(s);
					if (isNaN(date)) return s;

					return date.toLocaleDateString("en-US", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit"
					});
				},

				formatLongDate: function (value) {
					if (!value) return "";

					const date = new Date(value);
					if (isNaN(date))
						return String(value);

					return isNaN(date) ?
						String(value) :
						date.toLocaleDateString("en-US", {
							year: "numeric",
							month: "long",
							day: "numeric"
						});
				},

				formatPoints: function (value) {
					var amount = Number(value);
					return (amount < 0) ? "(" + Math.abs(amount) + ")" : Math.abs(amount);
				},

				pointsClass: function (value) {
					return (Number(value) < 0) ? "form-control reduced text-danger" : "form-control reduced";
				},

				loadCountries: function () {
					return $.ajax({
						url: "/api/countries?requireRegions=true",
						method: "GET",
						dataType: "json"
					})
						.done(response => {
							if (response.success) {
								this.countries = response.data;
								if (this.transaction?.shippingAddress?.region)
									this.onCountryChange();
							}
						})
						.fail((jqXHR, status, err) => {
							console.error("AJAX error loading countries:", status, err);
						});
				},

				loadTransaction: function () {
					var id = $modal.data("id");

					if (!id) {
						this.loadError = "No transaction id provided.";
						return;
					}

					this.isLoading = true;
					this.loadError = "";

					return $.ajax({
						url: "/api/transactions/" + encodeURIComponent(id),
						method: "GET",
						dataType: "json",
						headers: { "Accept": "application/json" },
						timeout: 15000
					})
						.done((response) => {
							if (response && response.success && response.data) {
								this.transaction = response.data;
							} else {
								this.loadError = (response && response.message) || "Unable to load transaction.";
							}
						})
						.fail((jqXHR, status) => {
							this.loadError = (jqXHR && jqXHR.status === 404) ? "Transaction not found (404)." :
								(status === "timeout" ? "Request timed out." : "Failed to load transaction.");
						});
				},

				cycleStatus: function () {
					let currentStatusIndex = this.statusList.indexOf(this.transaction.status);
					this.transaction.status = this.statusList[(currentStatusIndex + 1) % this.statusList.length];
				},

				save: function () {
					if (!this.transaction || !this.transaction.id)
						return;

					this.isSaving = true;

					return $.ajax({
						url: "/api/transactions/" + encodeURIComponent(this.transaction.id),
						method: "PUT",
						contentType: "application/json; charset=utf-8",
						dataType: "json",
						data: JSON.stringify(this.transaction),
						headers: { "Accept": "application/json" },
						timeout: 15000
					}).done((response) => {
						if (response && response.success) {
							this.isSaved = true;
							setTimeout(() => {
								this.close();
							}, 900);
						} else {
							this.alertMessage = (response && response.message) || "Unable to save transaction.";
						}
					}).fail((jqXHR, status) => {
						this.alertMessage = (jqXHR && jqXHR.status === 404) ? "Transaction could not found (404)." :
							(status === "timeout" ? "Request timed out." : "Unable to save transaction.");
					}).always(() => {
						this.isSaving = false;
					});
				},

				onCountryChange: function () {
					const selectedCountry = this.countries.find(c => c.code === this.transaction?.shippingInformation?.country);
					this.transaction.shippingInformation.region = (selectedCountry?.regions?.[0]?.code) || "";
				},

				clearState: function () {
					this.isLoading = false;
					this.isSaved = false;
					this.isSaving = false;
					this.alertMessage = "";
					this.alertErrors = [];

					this.transaction = {
						items: [],
						shippingAddress: {}
					};
				},

				close: function () {
					$modal.modal("hide");
				},

				isOlderThanThreeMonths: function (itemDate, initiatedOn) {
					if (!itemDate || !initiatedOn)
						return false;
					const item = new Date(itemDate);
					const initiated = new Date(initiatedOn);
					const diffTime = initiated - item;
					const diffDays = diffTime / (1000 * 60 * 60 * 24);
					return diffDays > 90;
				}
			},

			mounted: function () {
				$modal.off("show.bs.modal hidden.bs.modal");

				$modal.on("show.bs.modal", () => {
					this.clearState();
					this.loadTransaction()
						.always(() => {
							this.loadCountries();
							this.isLoading = false;
						});
				});

				$modal.on("shown.bs.modal", () => {
					$modal.find("#close-icon").focus();
				});
			}
		});
	}

	function open(id, onClose) {
		$modal.data("id", id).modal("show");

		if (onClose) {
			$modal.one('hidden.bs.modal', onClose);
		}
	}

	$(document)
		.off("click.transactionDetail", '[data-action="transaction-detail"]')
		.on("click.transactionDetail", '[data-action="transaction-detail"]', function (event) {
			event.preventDefault();

			const transactionId = Number(this.getAttribute("data-transaction-id"));
			if (transactionId)
				open(transactionId);
		});

	return { init, open };
})(jQuery, Vue);

App.TransactionDetail.init();